import { canUseDOM } from '@swf/core/utils';

interface StarsWeb {
  app: {
    timezone: string;
  };
  homegames: object;
  module: (route: string) => void;
}

export const nativeClient = canUseDOM && (window.starsweb as StarsWeb);
export const initHGNativeClient = () => {
  if (nativeClient && !nativeClient?.homegames) {
    nativeClient.module('homegames');
  }
};
